import React from "react";
import { firestore } from "../../../config/firebase";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Page() {
    const params = useParams()
    const [blog, setBlog] = useState({})
    useEffect(() => {
        const getBlog = async () => {
            try {
                const docRef = doc(firestore, "blogs", params.blogId);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setBlog(data);
                } else {
                    console.log("No such document!");
                }
            } catch (error) {
                console.error(error);
            }
        };

        getBlog();
    }, [params.blogId])

    return (
        <>
        <Helmet>
            <title>Ilmulquran Blog ,an online Quran Academy</title>
            <link rel="canonical" href="https://www.ilmulquran.online/blogs/" />
            <meta name="description"
    content="Explore Quran, Sunnah, and more. Dive into insightful articles on Islamic teachings. Join our journey!" 
  />
        </Helmet>
            <div className="mt-24 text-[#fffa8a]">
                <h1 className="text-[45px] underline text-center italic ">{blog.title} </h1>
                <img src={blog.fileURL} className="md:h-[45vh] mx-auto mt-7 " alt="" />
                <h2 className=" text-[#fffa8a] p-8 md:px-80 opacity-70 text-[25px] mt-4 "><span className="underline">Category</span> : {blog.category}</h2>
                <h1 className="text-[35px] underline text-center italic ">Description </h1>
                <p className="text-[#fffa8a] mt-2 px-8 md:px-80 sm:px-40 text-[20px] ">
                    {blog.description && blog.description.split(/\\/).map((part, index) => (
                        <span key={index}>
                            {part}
                            {index !== blog.description.split(/\\/).length - 1 && <br />}
                        </span>
                    ))}
                </p>
                <h2 className=" text-[#fffa8a] p-8 md:px-80 opacity-70 text-[25px] mt-4 "><span className="underline">Date Posted</span> : {blog.createdAt}</h2>

            </div>
        </>
    );
}
